import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { LOGO_URL, scrollToId } from "../constants";

const links = [
  { label: "The Work", id: "heart-of-work", testId: "nav-link-the-work" },
  { label: "The Collective", id: "the-collective", testId: "nav-link-the-collective" },
  { label: "Amber", id: "founder", testId: "nav-link-amber" },
  { label: "Resonance", id: "resonance", testId: "nav-link-resonance" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 350);
    } else {
      scrollToId(id);
    }
  };

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-700 ${
        scrolled ? "bg-[#faf8f4]/80 backdrop-blur-xl border-b hairline" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <button
          data-testid="nav-logo-button"
          onClick={() => go("hero")}
          className="flex items-center gap-3"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0a0908]">
            <img src={LOGO_URL} alt="The SEAL Collective emblem" className="h-8 w-8 object-contain" />
          </span>
          <span className="hidden text-[0.65rem] font-light uppercase tracking-[0.4em] text-black/70 sm:block">
            The SEAL Collective
          </span>
        </button>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => go(l.id)}
              className="text-[0.65rem] font-light uppercase tracking-[0.3em] text-black/55 transition-colors duration-500 hover:text-[#8a6d1f]"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button data-testid="nav-connect-button" onClick={() => go("contact")} className="btn-outline !px-5 !py-2.5">
          Connect
        </button>
      </div>
    </motion.header>
  );
};

export default Nav;
